import { styled } from '@mui/material';
import React from 'react';
import BackgroundNoise from '../../assets/patterns/background_noise.png';

const Root = styled('div')(({ theme, isActive }) => ({
  backgroundColor: isActive ? '#FCFDFD' : '#E9ECED', // Lighter when active
  backgroundImage: `url(${BackgroundNoise})`,
  backgroundRepeat: 'repeat',
  border: '1px solid rgba(255,255,255, 0.4)',
  display: 'flex',
}));

const WindowBackground = (
  {
    children,
    width = '100%',
    minWidth = '300px',
    height = '100%',
    radius = '0px',
    isActive = false,
  },
  ...props
) => {
  return (
    <Root
      isActive={isActive}
      sx={{
        width,
        minWidth,
        height,
        borderBottomLeftRadius: radius,
        borderBottomRightRadius: radius,
      }}
      {...props}
    >
      {children}
    </Root>
  );
};

export default WindowBackground;
